// 거래명세서 미리보기 — 장 나누기 결과를 공용 오버레이에 그린다.
//
// 확장코드 문서는 docNo가 같아도 별도 문서이므로 문서 단위로 이어서 그린다.

import { FileSpreadsheet } from 'lucide-react';
import { PrintPreviewOverlay } from '@/components/common/print-preview-overlay';
import { downloadInvoiceWorkbook } from './invoice-excel';
import type { InvoiceDocumentDto } from './invoice-document-types';
import { paginateDocument } from './invoice-paginate';
import { InvoiceSheet } from './invoice-sheet';

interface InvoicePreviewOverlayProps {
  docs: InvoiceDocumentDto[];
  onClose: () => void;
}

export function InvoicePreviewOverlay({ docs, onClose }: InvoicePreviewOverlayProps) {
  return (
    <PrintPreviewOverlay
      title={docs[0].header.titleText}
      orientation='portrait'
      onClose={onClose}
      actions={
        <button type='button' onClick={() => void downloadInvoiceWorkbook(docs)}>
          <FileSpreadsheet size={14} />
          엑셀
        </button>
      }
    >
      {docs.flatMap(doc =>
        paginateDocument(doc.groups).map((sheet, index) => (
          <InvoiceSheet
            key={`${doc.docNo}-${doc.geoEcode}-${index}`}
            header={doc.header}
            tableTitle={sheet.tableTitle}
            rows={sheet.rows}
          />
        ))
      )}
    </PrintPreviewOverlay>
  );
}
